__turbopack_context__.v({
  "active": "footer-module-sass-module__X5uZ9q__active",
  "age": "footer-module-sass-module__X5uZ9q__age",
  "footerCrypto": "footer-module-sass-module__X5uZ9q__footerCrypto",
  "fxRate": "footer-module-sass-module__X5uZ9q__fxRate",
  "socialLink": "footer-module-sass-module__X5uZ9q__socialLink",
  "socialLinks": "footer-module-sass-module__X5uZ9q__socialLinks",
});
